import React, { useEffect, useState } from 'react';
import Config from '../../../helpers/Config';

export default function ProductImage({ attachment, priority, ...props }) {
    let original = `${process.env.PUBLIC_URL || ''}/product-placeholder.svg`;
    try { if (attachment) original = new URL(attachment, Config.ADMIN_BASE_URL).href; } catch { /* Use placeholder. */ }
    const [failure, setFailure] = useState({ url: original, attempts: 0 });
    useEffect(() => { setFailure({ url: original, attempts: 0 }); }, [original]);
    const attempts = failure.url === original ? failure.attempts : 0;
    let src = original;
    if (attempts === 1) {
        const retry = new URL(original, window.location.origin);
        retry.searchParams.set('ukl-image-retry', '1');
        src = retry.href;
    } else if (attempts > 1) src = `${process.env.PUBLIC_URL || ''}/product-placeholder.svg`;
    return <img {...props} src={src} loading={priority ? 'eager' : 'lazy'} decoding="async"
        fetchpriority={priority ? 'high' : 'auto'}
        onError={attempts < 2 ? () => setFailure({ url: original, attempts: attempts + 1 }) : undefined} />;
}
